import styled from 'styled-components';
import {
  MAIN_BLUE, RAVEN, WATERMELON as ERROR_COLOR, WATERMELON,
} from '@espacePro/constants/admin-theme';
import Info from '@espaceProImages/info.inline.svg';
import { DEVICES } from '@espacePro/constants/breakpoints';

export const Title = styled.h2`
  font-size: 32px;
  font-weight: 800;
  letter-spacing: 0.2px;
  margin: 0;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: ${RAVEN};
  margin: 8px 0 0;
`;

export const FormBody = styled.div`
  margin: 32px 0;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.57;
  margin: 24px 0 8px;
  display: block;
`;

export const InputsGroupTitle = styled.h4`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.33;
  letter-spacing: 0.2px;
  margin: 0 0 4px;
`;

export const InputsHint = styled.p`
  font-size: 14px;
  margin: 4px 0 16px;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: ${RAVEN};
`;

export const MultipleInputsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px 32px 0;
`;

export const InputCell = styled.div`
  margin: 8px 8px 0 0;
`;

export const CheckboxRow = styled.div`
  margin-top: 16px;
`;

export const LargeInputContainer = styled.div`
  max-width: 524px;
`;

export const XLargeInputContainer = styled.div`
  max-width: 778px;
`;

export const MediumInputContainer = styled.div`
  max-width: 426px;
`;

export const SmallInputContainer = styled.div`
  width: 100%;

  @media ${DEVICES.LARGE} {
    max-width: 376px;
    margin-right: 12px;
  }
`;

export const XSmallInputContainer = styled.div`
  width: 100%;

  @media ${DEVICES.LARGE} {
    max-width: 296px;
    margin-right: 12px;
  }
`;

export const InputGroupRow = styled.div`
  margin-top: 32px;
`;

export const ButtonContainer = styled.div`
  margin-top: 24px;
`;

export const InfoIcon = styled(Info)`
  width: 16px;
  height: 16px;
  fill: ${MAIN_BLUE};
  margin-left: 6px;
`;

export const InputWithHintRow = styled.div`
  display: flex;
  align-items: center;
`;

export const ErrorMessage = styled.div`
  color: ${WATERMELON};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.57;
  letter-spacing: 0.3px;
  margin-top: 4px;
`;

export const ErrorMessageContainer = styled.div`
  color: ${ERROR_COLOR};
  font-size: 12px;
  line-height: 1.17;
  margin-top: 3px;
`;
